module.exports = __webpack_public_path__ + "img/pieles-metalicas.52b665de.jpg";